import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { ICiudadPrincipalHM } from '../models/ciudadprincipal';

@Injectable({
  providedIn: 'root'
})
export class CiudadesprincipalesService {

  private apiUrl: string ='';
  constructor(private http: HttpClient) { 
    this.apiUrl = environment.sUrlNomina + 'CiudadesPrincipales';
  }

  getListadoCiudadesPrincipales(): Observable<ICiudadPrincipalHM[]> {
    return this.http
      .get<ICiudadPrincipalHM[]>(this.apiUrl)
      .pipe(retry(1), catchError(this.handleError));
  }

  handleError(error:any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // client-side error
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.log(errorMessage);
    return throwError(() => {
        return errorMessage;
    });
  }
}
